import React, { useEffect, useState } from 'react';
import { CheckCircle2Icon, ChevronDownIcon, ChevronUpIcon, FacebookIcon, InstagramIcon, MailIcon, ShieldCheckIcon, StarIcon } from 'lucide-react';
const CHECKOUT_URL = 'https://megapack-maderoterapia-pro.impultienda.ar/checkout';
const faqs = [['Does it work if I am a beginner in wood therapy?', 'Yes. Volume 1 starts from the fundamentals: anatomy, tools and the base protocol. You do not need prior experience to understand and apply the material.'], ['How do I receive the material?', 'Instant PDF download as soon as your purchase is confirmed. Open it on desktop, tablet or phone, and print anything you need.'], ['Does it work if I already do massage or work in aesthetics?', 'Especially. The MegaPack is designed for any wellness professional who wants to add or improve wood therapy as a differentiating service.'], ['Is it a course with video lessons?', 'No. It is ready-to-use material in PDF format. No long videos and no platforms: open the volume, pick the protocol and apply it.'], ['Can I use the forms and templates with my clients?', 'Yes. The forms, consent sheets and handout material are designed to be used directly with your clients. You can personalize them with your name or logo.'], ['Does it work if I want to start selling sessions from scratch?', 'Yes. The 21-Day Agenda and the WhatsApp and Instagram scripts help you go from zero to a service that is organized and communicated.'], ['What if it is not for me?', 'You have a 7-day guarantee with a full refund, no questions asked.']];
const costRows = [['Searching for protocols before every session', '2+ unpaid working hours every week'], ['Not having a clear service menu', 'You charge less than your work is worth'], ['A client who cannot see documented results', 'Drops off after 2 sessions — you lose $40–150 per client'], ['Sessions with no defined structure', 'Your professional image at stake with every improvisation'], ['Not knowing how to offer packages', 'You keep charging per single session with no way to scale'], ['Tools with no clear protocol', 'You always use the same two and leave the kit unused']];
const testimonials = [{
  quote: 'Volume 2 is gold. Within 2 minutes I had the exact protocol with tool order and timing.',
  name: 'Rachel Owens',
  role: 'Certified wood therapist, Denver, CO',
  image: 'https://cdn.magicpatterns.com/patterns/generated-images/d254086f-3083-40d6-99ea-92fad4ca7ad5.jpg'
}, {
  quote: 'I sold my first 8-session package for $280 using the program template.',
  name: 'Emily Tan',
  role: 'Body therapist, Sydney, Australia',
  image: 'https://cdn.magicpatterns.com/patterns/generated-images/143cc77f-0bfb-497c-8da9-39bf8a5edb8f.jpg'
}, {
  quote: 'The WhatsApp scripts mean answering the price question no longer gives me anxiety.',
  name: 'Hannah Clarke',
  role: 'Wellness entrepreneur, Dublin, Ireland',
  image: 'https://cdn.magicpatterns.com/patterns/generated-images/e64e56c0-e711-4024-97e0-37413b78e340.jpg'
}, {
  quote: 'The client form bonus gave my service the image of a professional clinic.',
  name: 'Jasmine Patel',
  role: 'Pilates instructor, London, UK',
  image: 'https://cdn.magicpatterns.com/patterns/generated-images/4f8a4766-6792-4151-ae7f-e87d1d0e60e0.jpg'
}, {
  quote: 'The postpartum protocol let me charge double what a standard contouring session brings in.',
  name: 'Chloe Bennett',
  role: 'Manual therapist, Auckland, New Zealand',
  image: 'https://cdn.magicpatterns.com/patterns/generated-images/36866034-7d6e-44ce-a253-3e45def9b167.jpg'
}, {
  quote: 'I used to improvise every session. Now I work with my timeline in front of me and far more confidence.',
  name: 'Danielle Brooks',
  role: 'Wellness massage therapist, Atlanta, GA',
  image: 'https://cdn.magicpatterns.com/patterns/generated-images/8b065f46-b8e4-47ad-b9e9-002a9698737b.jpg'
}];
export function Pricing() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 23,
    minutes: 59,
    seconds: 34
  });
  const [openFaq, setOpenFaq] = useState<number | null>(0);
  useEffect(() => {
    const timer = window.setInterval(() => {
      setTimeLeft(current => {
        if (current.seconds) return {
          ...current,
          seconds: current.seconds - 1
        };
        if (current.minutes) return {
          ...current,
          minutes: current.minutes - 1,
          seconds: 59
        };
        if (current.hours) return {
          hours: current.hours - 1,
          minutes: 59,
          seconds: 59
        };
        return current;
      });
    }, 1000);
    return () => window.clearInterval(timer);
  }, []);
  const clock = `${String(timeLeft.hours).padStart(2, '0')}:${String(timeLeft.minutes).padStart(2, '0')}:${String(timeLeft.seconds).padStart(2, '0')}`;
  return <div className="w-full bg-cream" data-id="element-114" data-mp="23g2pp7z0yca0">
      <section className="bg-brand-900 px-4 py-11 text-center text-white sm:px-6" data-id="element-115" data-mp="27fjwc4q6tfgr">
        <p className="text-xs font-black tracking-[0.12em] text-accent" data-id="element-116" data-mp="2cffqlc931sj4">
          LAUNCH PRICE — CLOSES IN:
        </p>
        <p aria-live="polite" className="mt-3 font-mono text-4xl font-black tracking-tight text-white sm:text-6xl" data-id="element-117" data-mp="2hcy3teu4utwx">
          {clock}
        </p>
        <p className="mt-3 text-sm text-gray-300" data-id="element-118" data-mp="2r42dq04ybokw">
          After that it goes up to $47. It does not come back.
        </p>
        <div className="mx-auto mt-5 h-2 max-w-md overflow-hidden rounded-full bg-brand-800" data-id="element-119" data-mp="2v4cmtlo1iv3z">
          <div className="h-full w-[84%] rounded-full bg-accent" data-id="element-120" data-mp="305juzlu3hwb6" />
        </div>
        <p className="mt-2 text-xs text-brand-100" data-id="element-121" data-mp="35324pefxsfk8">
          84% of the launch-price spots are already taken
        </p>
      </section>

      <section id="pricing" className="mx-auto max-w-6xl scroll-mt-4 px-4 py-12 sm:px-6 md:py-20" data-id="element-122" data-mp="151vk1uaoe7f3">
        <div className="text-center" data-id="element-123" data-mp="10069sgva1xs2">
          <p className="text-xs font-bold uppercase tracking-[0.16em] text-brand-600" data-id="element-124" data-mp="1ernkh55ghurh">
            Get your MegaPack
          </p>
          <h2 className="mt-3 text-3xl font-black text-brand-900 md:text-4xl" data-id="element-125" data-mp="19zneow2pg7mz">
            Everything you need to work with a system
          </h2>
        </div>
        <div className="mx-auto mt-9 max-w-2xl" data-id="element-126" data-mp="1jqrq5lt69ad2">
          <article className="flex flex-col rounded-2xl border border-brand-100 bg-white p-6 text-center shadow-sm md:p-8" data-id="element-127" data-mp="1jpyrl84d9r60">
            <p className="text-xs font-black tracking-[0.14em] text-brand-600" data-id="element-128" data-mp="1xnncuh2cj0bl">
              WOOD THERAPY PRO MEGAPACK
            </p>
            <h3 className="mt-2 text-2xl font-black text-brand-900" data-id="element-129" data-mp="3b6zkwb4ulx8">
              WOOD THERAPY PRO MEGAPACK
            </h3>
            <p className="mt-2 text-sm text-gray-600" data-id="element-130" data-mp="3ujukjb5go749">
              6 Volumes + 5 Bonuses — Every protocol solved for you.
            </p>
            <ul className="mt-6 space-y-3 text-sm text-gray-700" data-id="element-131" data-mp="2ezc477m5fnlj">
              {['6 complete volumes with 300+ pages', '5 strategic bonuses included', 'Printable protocols, forms and checklists'].map(item => <li key={item} className="flex gap-2" style={{
              textAlign: "left"
            }} data-id="element-132" data-mp="257fs2sn89wyb">
                  <CheckCircle2Icon className="h-5 w-5 shrink-0 text-brand-500" data-id="element-133" data-mp="1r8g4lobgbo3q" />
                  {item}
                </li>)}
            </ul>
            <div className="mt-8" data-id="element-134" data-mp="1hcd40mw8zxiw">
              <p data-id="element-135" data-mp="1hd4rtbjlsqym">
                <span className="mr-2 text-lg text-gray-400 line-through" data-id="element-136" data-mp="1hdo4oduecp5s">
                  $43
                </span>
                <strong className="font-black text-brand-900 text-[48px]" data-id="element-137" data-mp="3bpl16l7p4l7p">
                  $13.90
                </strong>{' '}
                <span className="font-bold text-brand-600" data-id="element-138" data-mp="3gnmm7boomult">USD</span>
              </p>
              <p className="mt-1 text-xs text-gray-500" data-id="element-139" data-mp="24fu5hd85w6xy">
                The product will be charged in your local currency.
              </p>
            </div>
            <a href={CHECKOUT_URL} className="mt-4 block rounded-xl border-2 border-brand-600 px-4 py-3.5 text-center text-sm font-extrabold text-brand-700 transition-colors hover:bg-brand-50" data-id="element-140" data-mp="1zic4c90dyw0i">
              I WANT MY MEGAPACK
            </a>
          </article>
        </div>
      </section>

      <section className="mx-auto max-w-6xl px-4 py-12 sm:px-6 md:py-20" data-id="element-141" data-mp="1gp8b2or2yl6f">
        <h2 className="text-center text-3xl font-black text-brand-900" data-id="element-142" data-mp="1gs47u9r6z3ta">
          More professionals, more confidence
        </h2>
        <div className="mt-9 grid gap-4 sm:grid-cols-2 md:grid-cols-3" data-id="element-143" data-mp="16s3paq15crq5">
          {testimonials.map(testimonial => <article key={testimonial.name} className="flex flex-col rounded-xl border border-brand-100 bg-white p-5" data-id="element-144" data-mp="363d4d5yab8ou">
              <div className="flex gap-0.5 text-accent" aria-label="5 out of 5 stars" data-id="element-145" data-mp="38pdroniiuj7d">
                {[1, 2, 3, 4, 5].map(star => <StarIcon key={star} className="h-4 w-4 fill-current" aria-hidden="true" data-id="element-146" data-mp="3iexda0xmcr5x" />)}
              </div>
              <blockquote className="mt-3 text-sm leading-relaxed text-gray-700" data-id="element-147" data-mp="2pqhztiu4ygwp">
                “{testimonial.quote}”
              </blockquote>
              <footer className="mt-auto flex items-center gap-3 pt-4" data-id="element-148" data-mp="2uq4g6159gd9q">
                <img src={testimonial.image} alt={testimonial.name} className="h-11 w-11 shrink-0 rounded-full border border-brand-100 object-cover" data-id="element-149" data-mp="2zo67188xhgvr" />
                <div className="min-w-0" data-id="element-150" data-mp="exf7dz1epu85">
                  <p className="text-sm font-bold text-brand-900" data-id="element-151" data-mp="f0jkxn0ri2bh">
                    {testimonial.name}
                  </p>
                  <p className="text-xs text-gray-500" data-id="element-152" data-mp="350vqncmywgtz">{testimonial.role}</p>
                </div>
              </footer>
            </article>)}
        </div>
      </section>

      <section className="bg-brand-50 px-4 py-12 sm:px-6" data-id="element-153" data-mp="3dsxn6ztx1cyz">
        <div className="mx-auto max-w-3xl rounded-3xl border-2 border-brand-100 bg-white p-7 text-center shadow-sm md:p-10" data-id="element-154" data-mp="3dtfs0kun8zii">
          <ShieldCheckIcon className="mx-auto h-12 w-12 text-brand-600" data-id="element-155" data-mp="3itlfdotvrzus" />
          <h2 className="mt-4 text-3xl font-black text-brand-900" data-id="element-156" data-mp="2m3azu00n786q">
            7-DAY GUARANTEE — NO QUESTIONS ASKED
          </h2>
          <p className="mt-4 leading-relaxed text-gray-600" data-id="element-157" data-mp="2v267lgjc4qc5">
            Open the volumes. Use them in real sessions. If within 7 days it is
            not what you expected, we refund 100%, with no forms and no
            complications.
          </p>
          <p className="mt-5 text-sm font-bold text-brand-600" data-id="element-158" data-mp="abfg4ulyw9zm">
            Refund rate: under 1%.
          </p>
        </div>
      </section>

      <section className="bg-white px-4 py-12 sm:px-6 md:py-20" data-id="element-159" data-mp="1zt2vhyk84jgk">
        <div className="mx-auto max-w-3xl" data-id="element-160" data-mp="1zsazwnqmmlqa">
          <h2 className="text-center text-3xl font-black text-brand-900" data-id="element-161" data-mp="1uu9jybohz2j1">
            Frequently asked questions
          </h2>
          <div className="mt-8 space-y-3" data-id="element-162" data-mp="1q27ybz5fvzgc">
            {faqs.map(([question, answer], index) => {
            const isOpen = openFaq === index;
            return <div key={question} className="overflow-hidden rounded-xl border border-gray-200" data-id="element-163" data-mp="1h2bce5afpeoz" data-mpi={index}>
                  <button type="button" onClick={() => setOpenFaq(isOpen ? null : index)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 bg-cream px-5 py-4 text-left text-sm font-bold text-brand-900" data-id="element-164" data-mp="1c26vie5m6hy8">
                    {question}
                    {isOpen ? <ChevronUpIcon className="h-5 w-5 shrink-0" data-id="element-165" data-mp="2wk4s7t6bb6bd" /> : <ChevronDownIcon className="h-5 w-5 shrink-0" data-id="element-166" data-mp="usl2cux4au43" />}
                  </button>
                  {isOpen && <div className="bg-white px-5 py-4 text-sm leading-relaxed text-gray-600" data-id="element-167" data-mp="kwi4i19athmy">
                      {answer}
                    </div>}
                </div>;
          })}
          </div>
        </div>
      </section>

      <section className="bg-brand-900 px-4 py-12 text-white sm:px-6 md:py-20" data-id="element-168" data-mp="1dikopa1kpv3t">
        <div className="mx-auto max-w-6xl text-center" data-id="element-169" data-mp="1ij8gvz1jghzm">
          <h2 className="text-3xl font-black md:text-4xl" data-id="element-170" data-mp="14kijsjepyib9">
            What does it cost to keep improvising?
          </h2>
          <p className="mt-4 text-brand-100" data-id="element-171" data-mp="18k9gf3qxfsnp">
            Your next client could experience something completely different.
          </p>
          <div className="mt-8 overflow-x-auto rounded-xl border border-brand-700 text-left" data-id="element-172" data-mp="3pckn7sforcpz">
            <table className="min-w-[650px] w-full text-sm" data-id="element-173" data-mp="3t9p2xmj44v7j">
              <thead data-id="element-174" data-mp="3lr8zis1qrhzk">
                <tr className="bg-brand-800" data-id="element-175" data-mp="3lqftjtalwwih">
                  <th className="p-4" data-id="element-176" data-mp="3gtpdv72ps2xl">Without the MegaPack</th>
                  <th className="p-4" data-id="element-177" data-mp="3gva78tdalftv">Real cost</th>
                </tr>
              </thead>
              <tbody data-id="element-178" data-mp="3vposl0kbx1bp">
                {costRows.map(([without, cost]) => <tr key={without} className="border-t border-brand-700" data-id="element-179" data-mp="3qsolqnfnnujj">
                    <td className="p-4 text-brand-100" data-id="element-180" data-mp="330zsn4v0f21j">{without}</td>
                    <td className="p-4 font-semibold text-white" data-id="element-181" data-mp="2y2pwos1gnxev">{cost}</td>
                  </tr>)}
              </tbody>
            </table>
          </div>
          <p className="mt-10 font-serif text-2xl italic text-accent" data-id="element-182" data-mp="3csx4mdtudy1b">
            “Your next session can be the most professional one you have ever
            given.”
          </p>
          <div className="mx-auto mt-10 max-w-3xl rounded-3xl bg-white p-7 text-brand-900 md:p-10" data-id="element-183" data-mp="2k9qg0mpxzx5q">
            <h3 className="text-3xl font-black" data-id="element-184" data-mp="2fboxq40cc1vb">
              Stop improvising. Start working with a system.
            </h3>
            <p className="mt-4 text-sm leading-relaxed text-gray-600" data-id="element-185" data-mp="1ij0ajxwmxr3q">
              Join wellness professionals who already run sessions with a clear
              protocol, clients who come back and a service that feels premium.
            </p>
            <div className="mt-6 grid gap-3 border-y border-brand-100 py-5 text-left text-sm sm:grid-cols-2" data-id="element-186" data-mp="1wchxztsfznz1">
              {['Your 300 pages of protocols available', 'A proven method, area by area', 'Programs with documented follow-up', 'Closed packages and programs', 'Every tool with its exact function', 'A professional image from first contact'].map(item => <span key={item} className="flex gap-2 font-semibold" data-id="element-187" data-mp="fyhwwfhv1sa7">
                  <CheckCircle2Icon className="h-5 w-5 shrink-0 text-brand-500" data-id="element-188" data-mp="g0ckk1kinyhz" />
                  {item}
                </span>)}
            </div>
            <p className="mt-6 text-xs font-bold tracking-wider text-brand-600" data-id="element-189" data-mp="debre3dlltrj">
              THE PRICE CLOSES IN: {clock}
            </p>
            <p className="mt-2 font-bold text-[40px]" data-id="element-190" data-mp="3nqm5x3f5qzn">$13.90 USD</p>
            <a href={CHECKOUT_URL} className="mt-6 block rounded-xl bg-brand-600 px-5 py-4 text-sm font-extrabold text-white transition-colors hover:bg-brand-700" data-id="element-191" data-mp="3oa7zow6wziy">
              YES, I WANT MY WOOD THERAPY PRO MEGAPACK
            </a>
            <p className="mt-4 text-xs text-gray-500" data-id="element-192" data-mp="recvdrp5thb8">
              100% secure payment · Instant access · 7-day guarantee
            </p>
          </div>
        </div>
      </section>

      <footer className="bg-[#102015] px-4 py-10 text-center text-sm text-gray-400 sm:px-6" data-id="element-193" data-mp="idenuzfiirnw">
        <div className="mx-auto max-w-4xl" data-id="element-194" data-mp="374z40gy5cqud">
          <p className="font-bold text-white" data-id="element-195" data-mp="375sbjk4xjkdk">WOOD THERAPY PRO MEGAPACK™</p>
          <p className="mx-auto mt-3 max-w-xl leading-relaxed" data-id="element-196" data-mp="331t21li2hltp">
            The most complete system of ready-to-use protocols for wood therapy
            professionals. Because working on your clients' bodies should not
            start with doubts the night before.
          </p>
          <div className="mt-7 flex flex-wrap justify-center gap-x-6 gap-y-3" data-id="element-197" data-mp="2ummw7m461k6b">
            <a href="mailto:tuproximonivel216@gmail.com" className="flex items-center gap-2 hover:text-white" data-id="element-198" data-mp="2zkoi0esz7xlh">
              <MailIcon className="h-4 w-4" data-id="element-199" data-mp="2lryqjuuoi0gz" />
              tuproximonivel216@gmail.com
            </a>
            <a href="https://www.instagram.com/tuproximonivel216/" target="_blank" rel="noreferrer" className="flex items-center gap-2 hover:text-white" data-id="element-200" data-mp="2qlkvt1yij22r">
              <InstagramIcon className="h-4 w-4" data-id="element-201" data-mp="2gs45i7xl453u" />
              Instagram
            </a>
            <a href="https://www.facebook.com/profile.php?id=61555374626740" target="_blank" rel="noreferrer" className="flex items-center gap-2 hover:text-white" data-id="element-202" data-mp="22ws63n8hhqgl">
              <FacebookIcon className="h-4 w-4" data-id="element-203" data-mp="1j9f86enobu5y" />
              Facebook
            </a>
          </div>
        </div>
      </footer>
    </div>;
}